import { useState, useCallback } from 'react';
import { LightboxItem, LightboxPhoto } from '@alltrails/denali/types';

const useLightboxState = (
  items: LightboxItem[],
  onNavigate?: (newActiveIndex: number) => Promise<LightboxPhoto>
): { currentPhoto: LightboxPhoto | undefined; handleLoadPhoto: (activeIndex: number) => Promise<void> } => {
  const [currentPhoto, setCurrentPhoto] = useState<LightboxPhoto | undefined>();

  const handleLoadPhoto = useCallback(
    async (activeIndex: number) => {
      try {
        const response = await onNavigate?.(activeIndex);
        if (response) {
          const url = items[activeIndex]?.url ?? items[activeIndex]?.imgUrl ?? response?.photo?.image.url ?? '';
          setCurrentPhoto({ ...response, url });
        } else {
          setCurrentPhoto(undefined);
        }
      } catch {
        setCurrentPhoto(undefined);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items, onNavigate]
  );

  return { currentPhoto, handleLoadPhoto };
};

export default useLightboxState;
